<template>
  <v-progress-circular
    v-if="isLoading"
    :size="70"
    :width="7"
    color="primary"
    indeterminate
    class="centered"
  ></v-progress-circular>
  <div v-else>
    <div class="row brand-dropdown">
      <div class="col-4">
        <BrandDropdown
          v-model="brandSelected"
          @setBrand="setBrand"
        ></BrandDropdown>
      </div>
    </div>
    <div class="mt-3">
      <div class="row">
        <div class="d-flex align-items-center justify-content-start col">
          <span style="margin-right: 1rem">Show</span>
          <b-form-select
            class="form-control"
            style="width: 20%"
            v-model="perPage"
            :options="pageOptions"
            @change="onChangeEntries"
          ></b-form-select>
          <span style="margin-left: 1rem">entries</span>
        </div>
        <div class="d-flex align-items-center justify-content-end col">
          <label for="searchText" class="mx-3">Search: </label>
          <input
            id="searchText"
            type="text"
            v-model="searchText"
            class="form-control w-50"
            @change="getList"
          />
        </div>
      </div>

      <b-table
        class="table table-responsive table-bordered mt-5"
        hover
        responsive
        :fields="fields"
        :items="listStores"
        :per-page="perPage"
        @sort-changed="sortCompare"
      >
        <template #cell(action)="data">
          <div class="d-flex justify-content-evenly">
            <button v-if="isServiceReservationEnabled"
              class="btn btn-success mr-4"
              @click="redirectToCounterService(data.item.storeCode)"
            >
               Service
            </button>
            <router-link
              :to="{
                name: 'DetailStore',
                query: { id: data.item.storeCode }
              }"
              class="btn btn-outline-primary"
              >Detail</router-link
            >
          </div>
        </template>
      </b-table>
      <b-pagination
        :total-rows="totalItems"
        v-model="currentPage"
        :per-page="perPage"
        class="my-0"
        aria-controls="my-table"
        @input="changePage"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
import StoreService from "@/services/api/store.service";
import BrandDropdown from "components/Brand/BrandDropdown";
import DefaultListViewData from "@/views/defaultListViewData";
import { PrivilegeStorageService } from "services/storage.service";
export default {
  components: {
    BrandDropdown,
  },
  computed: {
    isServiceReservationEnabled() {
      return process.env.VUE_APP_FEATURE_SERVICE_RESERVATION_ENABLED === 'true';
    },
  },
  data() {
    return {
      ...DefaultListViewData,
      listStores: [],
      isLoading: true,
      fields: [
        {
          key: "storeCode",
          label: "Store Code",
          sortable: true,
        },
        {
          key: "storeName",
          label: "Store Name",
        },
        {
          key: "displayName",
          label: "Store Display Name",
        },
        {
          key: "brandCode",
          label: "Brand Code",
          sortable: true,
        },
        {
          key: "status",
          label: "Status",
          sortable: true,
        },
        {
          key: "storeType",
          label: "Store Type",
        },
        {
          key: "action",
          label: "Action",
        },
      ],
    };
  },
  mounted() {
    this.getList(this.sort);
    this.brandSelected =
      JSON.parse(PrivilegeStorageService.getStoredBrand()) || {};
    let storedParams =
      JSON.parse(PrivilegeStorageService.getStoredParams()) || {};
    if (storedParams) {
      this.currentPage = storedParams.currentPage || 1;
      this.perPage = storedParams.limit || 10;
      this.sort.key = storedParams.sortColumn;
      this.sort.type = storedParams.sortType;
      this.searchText = storedParams.key;
    }
  },
  methods: {
    async getList(sort) {
      try {
        const param = {
          currentPage: this.currentPage,
          limit: this.perPage,
          brands:
            this.brandSelected?.id ? [this.brandSelected.id] : [],
          sortColumn: sort.key || "id",
          sortType: sort.type || "desc",
          key: this.searchText,
        };
        await PrivilegeStorageService.setStoredParams(param);
        await StoreService.getListStore(param)
          .then((res) => {
            const data = res.data;
            this.totalItems = data.totalItems;
            this.listStores = data.store;
            this.isLoading = false;
          })
          .catch((err) => {
            console.log("Error: ", err);
            this.isLoading = false;
          });
      } catch (error) {
        console.log("Error: ", error);
        this.isLoading = false;
      }
    },
    redirectToCounterService(storeCode) {
      this.isLoading = true;
      try {
        StoreService.getDetailStore(storeCode)
          .then((res) => {
            const data = res.data;
            const storeInfo = data.store;
            const brandCode = storeInfo.brandCode;
            const brandName = storeInfo.brandName;
            const storeCode = storeInfo.storeCode;
            const name = storeInfo.name;
            const displayName = storeInfo.displayName;
            const storeDetails = {
              brandCode,
              brandName,
              storeCode,
              name,
              displayName,
            };
            sessionStorage.setItem(
              "storeDetails",
              JSON.stringify(storeDetails)
            );
            this.$router.push({
              name: "CounterService",
            });
            this.isLoading = false;
          })
          .catch((err) => {
            console.log("Catch API: ", err);
          });
      } catch (error) {
        console.log("Error: ", error);
      }
    },
    setBrand(brand) {
      this.brandSelected = brand || "";
      PrivilegeStorageService.setStoredBrand(this.brandSelected);
      this.getList(this.sort);
    },
    sortCompare(e) {
      this.sort = {
        key: e.sortBy,
        type: e.sortDesc ? "desc" : "asc",
      };
      this.getList(this.sort);
    },
    changePage() {
      this.getList(this.sort);
    },
    onChangeEntries() {
      this.getList(this.sort);
    },
  },
};
</script>

<style lang="scss">
.table {
  margin: 1rem 0;
}
.centered {
  position: absolute;
  top: 45%;
  left: 50%;
}
.btn-del {
  color: red;

  .btn-del:hover {
    color: white;
  }
}
.content-dialog {
  height: 300px;
  background: #fff;

  h3 {
    text-align: center;
    padding: 5rem 0 2rem;
  }

  .btn-back {
    border: 1px solid #1976d2;
    width: 28%;
    height: 39px;
    border-radius: 25px;
    color: #1976d2;
  }
  .btn-back:hover {
    text-decoration: underline;
  }
}
</style>
